<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="businessform"
          status-icon
          :model="businessform"
          :rules="rules"
          label-width="120px"
          class="businessInfo"
          style="width: 90%;"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
        <el-row>
            <el-col>
              <el-form-item label="商户图片" prop="BusinessIcon">
                  <el-upload
                    class="avatar-uploader"
                    accept=".jpeg,.jpg,.png,.gif"
                    :show-file-list="false"
                    :http-request="httpRequest"
                    :data="uploadData"
                    :before-upload="beforeupload"
                    :on-success="uploadsuccess"
                    :on-progress="uploadProgress"
                    :on-error="uploadError"
                    :on-preview="handlePreview">
                    <img v-if="businessform.BusinessIcon" :src="businessform.BusinessIcon"  class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png/gif文件，且不超过2M</div>
                  </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="所属景区" prop="ScenicUUID">
                  <el-select  filterable placeholder="请选择"  v-model.trim="businessform.ScenicUUID">
                      <el-option
                        v-for="item in Scenics"
                        :key="item.ScenicUUID"
                        :label="item.ScenicName"
                        :value="item.ScenicUUID">
                      </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="商户编号" prop="BusinessCode">
                <el-input
                  v-model.trim="businessform.BusinessCode" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商户名称" prop="BusinessName">
                <el-input v-model.trim="businessform.BusinessName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商户种类" prop="BusinessTypeId">
                  <el-select  filterable placeholder="请选择"  v-model.trim="businessform.BusinessTypeId">
                    <el-option
                      v-for="item in BusinessTypes"
                      :key="item.BusinessTypeId"
                      :label="item.BusinessTypeName"
                      :value="item.BusinessTypeId">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="商户类型" prop="BusinessCategory" >
                   <el-select  filterable placeholder="请选择"  v-model.trim="businessform.BusinessCategory" :disabled="Isdisabled">
                    <el-option
                      v-for="item in Categories"
                      :key="item.CategoryId"
                      :label="item.CategoryName"
                      :value="item.CategoryId">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人" prop="ContactPerson">
                  <el-input v-model.trim="businessform.ContactPerson"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="Phone">
                  <el-input v-model.trim="businessform.Phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="企业名称" prop="CompanyName">
                  <el-input v-model.trim="businessform.CompanyName" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法定代表人" prop="ContactName">
                  <el-input v-model.trim="businessform.ContactName" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法人证件类型" prop="CertificateType">
                  <el-select  filterable placeholder="请选择"  v-model.trim="businessform.CertificateType" :disabled="Isdisabled">
                    <el-option
                      v-for="item in CertificateTypes"
                      :key="item.CertificateTypeNo"
                      :label="item.CertificateTypeName"
                      :value="item.CertificateTypeNo">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="企业证件类型" prop="CompanyCertType">
                  <el-select  filterable placeholder="请选择"  v-model.trim="businessform.CompanyCertType" :disabled="Isdisabled">
                    <el-option
                      v-for="item in CompanyCertTypes"
                      :key="item.CompanyCertTypeNo"
                      :label="item.CompanyCertTypeName"
                      :value="item.CompanyCertTypeNo">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业证件编号" prop="CompanyCertNo">
                  <el-input v-model.trim="businessform.CompanyCertNo" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法人证件编号" prop="CertificateNo">
                  <el-input v-model.trim="businessform.CertificateNo" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="收款户名" prop="AccountName">
                  <el-input v-model.trim="businessform.AccountName" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收款账号" prop="Account">
                  <el-input v-model.trim="businessform.Account" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收款账户类型" prop="AccountType">
                  <el-select  filterable placeholder="请选择"  v-model.trim="businessform.AccountType" :disabled="Isdisabled">
                    <el-option
                      v-for="item in AccountTypes"
                      :key="item.AccountTypeId"
                      :label="item.AccountTypeName"
                      :value="item.AccountTypeId">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="收款银行" prop="BankNo">
                  <el-select  filterable placeholder="请选择"  v-model.trim="businessform.BankNo" :disabled="Isdisabled">
                    <el-option
                      v-for="item in Banks"
                      :key="item.BankNo"
                      :label="item.BankName"
                      :value="item.BankNo">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预留手机号" prop="MobilePhone">
                  <el-input v-model.trim="businessform.MobilePhone" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="三方协议 " prop="Announce">
                   <el-select  filterable placeholder="请选择"  v-model.trim="businessform.Announce" :disabled="Isdisabled">
                    <el-option
                      v-for="item in Announces"
                      :key="item.AnnounceId"
                      :label="item.AnnounceName"
                      :value="item.AnnounceId">
                    </el-option>
                   </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="businessform.isPassed">
            <el-col :span="8">
              <el-form-item label="签约协议号 " prop="SubMerSignNo">
                  <el-input v-model.trim="businessform.SubMerSignNo" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="二级商户状态" prop="StatusMessage">
                  <el-input v-model.trim="businessform.StatusMessage" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="1!=1">
              <el-form-item label="二级商户种类 " prop="SubMerchantSort">
                  <el-input v-model.trim="businessform.SubMerchantSort" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="1!=1">
            <el-col :span="8">
              <el-form-item label="审核状态 " prop="isPassed">
                  <el-input v-model.trim="businessform.isPassed" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="账户状态" prop="AccStatus">
                  <el-input v-model.trim="businessform.AccStatus" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否是农行账号" prop="IsABCAccount">
                  <el-input v-model.trim="businessform.IsABCAccount" :disabled="Isdisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="8">
              <el-form-item label="地址" prop="Address">
                  <el-input v-model.trim="businessform.Address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经度" prop="Longitude">
                  <el-input v-model.trim="businessform.Longitude"></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="纬度" prop="Latitude">
                  <el-input v-model.trim="businessform.Latitude"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="说明" prop="Remarks">
                  <el-input v-model.trim="businessform.Remarks"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="分账比例" prop="Proportion" v-if="this.LoginIsMain=='1'">
                  <el-input-number :precision="2" :step="1" :min="0" :max="100" v-model.trim="businessform.Proportion"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="是否启用" prop="BusinessState" v-if="this.LoginIsMain=='1'">
                   <el-switch 
                    active-value='1'
                    inactive-value='0'
                    v-model.trim="businessform.BusinessState">
                  </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否同步到农行" prop="IsSyncToNH" v-if="this.LoginIsMain=='1'">
                   <el-switch 
                    active-value='1'
                    inactive-value='0'
                    v-model.trim="businessform.IsSyncToNH">
                  </el-switch>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="是否是主商户" prop="LoginIsMain" v-if="this.LoginIsMain=='1'">
                   <el-switch 
                    active-value='1'
                    inactive-value='0'
                    v-model.trim="businessform.IsMain">
                  </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button type="primary" @click="OnReview('businessform')" v-if="IsFinish">提交审核</el-button>
        <el-button type="primary" @click="Onsubmit('businessform')" v-if="IsEdit" >提交</el-button>
        <el-button @click="OnCancel" v-if="IsEdit">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
</style>


<script>
import WebApis from "../../../apis";
import utils from "../../../../../../utils";
import { showLoading, hideLoading } from "../../../../../../loading";
import ZJApp from "../../../../../app";

export default {
  name: "BusinessInfoPage",
  controller: "UI",
  action: "BusinessesInfo",
  data() {
    var checkIcon = (rule,value,callback)=>{
      if(!value)
      {
         callback(new Error('商户图片不为空!'));
      }
      else
      {
        callback();
      }
    };
    return {
      businessform: {
        BusinessIcon :"",
        ScenicUUID:"",
        BusinessCode :"",
        BusinessName :"",
        CompanyName:"",
        ContactName : "",
        CompanyCertNo : "",
        CertificateNo : "",
        AccountName : "",
        Account : "",
        AccountType : "",
        BankNo:"",
        BankName :"",
        MobilePhone : "",
        Announce : "",
        CertificateType : "",
        CompanyCertType :"",
        BusinessTypeId :"",
        BusinessCategory : 2,
        ContactPerson :"",
        Phone :"",
        Remarks:"",
        Address :"",
        Longitude : "",
        Latitude : "",
        BusinessState : '1',
        SubMerSignNo : "",
        StatusMessage : "",
        SubMerchantSort : "",
        isPassed : "",
        AccStatus : "",
        IsABCAccount : "",
        Description : "",
        IsSyncToNH:"1",
        Proportion:0,
        IsMain:0
      },
      Business_Code:"",
      Isdisabled:false,
      LoginBusiness:"",
      LoginIsMain:"0",
      AccountTypes:[
        {
          AccountTypeId:'401',
          AccountTypeName:'借记卡'
        },
        {
          AccountTypeId:'601',
          AccountTypeName:'对公卡'
        }
      ],
      CertificateTypes:[
        {
            CertificateTypeNo:'I',
            CertificateTypeName:'身份证'
        },
        {
            CertificateTypeNo:'P',
            CertificateTypeName:'护照'
        },
        {
            CertificateTypeNo:'G',
            CertificateTypeName:'军官证'
        },
        {
            CertificateTypeNo:'U',
            CertificateTypeName:'其它证件'
        }
      ],
      CompanyCertTypes:[
        {
          CompanyCertTypeNo:'U',
          CompanyCertTypeName:'营业执照'
        },
        {
          CompanyCertTypeNo:'Y',
          CompanyCertTypeName:'组织机构代码证'
        },
        {
          CompanyCertTypeNo:'V',
          CompanyCertTypeName:'统一社会信用代码'
        }
      ],
      Categories:[
        {
          CategoryId:1,
          CategoryName:"自然人"
        },
        {
          CategoryId:2,
          CategoryName:"企业商户"
        },
        {
          CategoryId:3,
          CategoryName:"个体工商户"
        },
      ],
      Announces:[
        {
          AnnounceId:'1',
          AnnounceName:'已声明'
        }
      ],
      rules: {
        BusinessIcon:[
           { validator:checkIcon, trigger: "change" }
        ],
        ScenicUUID:[
          { required: true, message: "请选择景区", trigger: "change" }
        ],
        BusinessCode: [
          { required: true, message: "请输入商户编号", trigger: "blur" }
        ],
        BusinessName: [
          { required: true, message: "请输入商户名称", trigger: "blur" }
        ],
        BusinessTypeId: [
          { required: true, message: "请选择商户种类", trigger: "change" }
        ],
        BusinessCategory: [
          { required: true, message: "请选择商户类型", trigger: "change" }
        ],
        ContactPerson: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        Phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        CompanyName:[
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        ContactName:[
          { required: true, message: "请输入法人", trigger: "blur" }
        ],
        CertificateType:[
          { required: true, message: "请选择法定代表人证件类型", trigger: "change" }
        ],
        CertificateNo:[
          { required: true, message: "请输入法定代表人证件编号", trigger: "blur" }
        ],
        CompanyCertType:[
          { required: true, message: "请选择企业证件类型", trigger: "change" }
        ],
        CompanyCertNo:[
          { required: true, message: "请输入企业证件编号", trigger: "blur" }
        ],
        AccountName:[
          { required: true, message: "请输入收款户名", trigger: "blur" }
        ],
        Account:[
          { required: true, message: "请输入收款账号", trigger: "blur" }
        ],
        BankNo:[
          { required: true, message: "请选择银行卡开户行", trigger: "change" }
        ],
        MobilePhone:[
          { required: true, message: "请输入银行预留手机号", trigger: "blur" }
        ],
        AccountType:[
          { required: true, message: "请选择收款账户类型", trigger: "change" }
        ],
        Announce:[
          { required: true, message: "请选择是否已签署三方协议", trigger: "change" }
        ]
      },
      resData: "",
      isPassed:"",
      Scenics:[],
      Banks:[],
      loading: false,
      loadingText: "加载中...",
      uploadData: {
        module: "BusinessManager", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      BusinessTypes:[]
    };
  },
  props: {
    Business_Id: {
      type: String,
      default: "",
    },
    IsEdit: {
      type: Boolean,
      default: true,
    },
    IsFinish: {
      type: Boolean,
      default: true,
    },
  },
  created: function () {
    this.init();
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    // 初始化
    init() {
       return utils.waitAll([
         ()=>this.GetBanks(),
         ()=>this.GetLoginBusiness(),
         () => this.GetScenics(),
         ()=>this.GetBusinessType()]).then(()=>{
            this.GetInfo();
          });
    },
    GetLoginBusiness()
    {
      let user = this.user;

      if(user.LoginName!="admin")
      {
        this.Business_Code=user.LoginName;
      }
      else
      {
        this.LoginIsMain="1";
        this.Business_Code="";
      }

       let BusinessSearch={
        BusinessCode: this.Business_Code!=""?this.Business_Code:null
      }

      return new WebApis.BusinessApi()
        .GetItemByBusinessCode(BusinessSearch)
        .then((res)=>{
            console.log("商户信息",res);
            this.LoginBusiness = res.data.Data;
            this.LoginIsMain=this.LoginBusiness.IsMain;
            if(user.LoginName=="admin")
            {
              this.LoginIsMain="1";
            }
        });
    },
    beforeupload: function (file) {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('上传头像图片只能是 JPG、PNG、GIF 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }

      
      this.loading = true;
      this.loadingText = "上传中... 0%";

      this.uploadData.assocID = this.uuid;

      this.loading = false;
      
      return isImage && isLt2M;
    },
    uploadsuccess: function (file) {
      this.businessform.BusinessIcon = file.DownloadPath;
      console.log("上传成功");
       this.$message({
            showClose: true,
            message: "上传成功!",
            type: "success",
          });
      this.loading = false;
      this.$refs["businessform"].validateField('BusinessIcon')
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
       console.log(file);
      // document.location.href = file.url;
    },
    Onsubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveData();
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnReview(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          let RegSubMerInfoRequest={
            SubMerId:this.businessform.BusinessCode,
            SubMerName:this.businessform.BusinessName,
            SubMerType:this.businessform.BusinessCategory+'',
            SubMerSort:"",
            Status:"1",
            ContactName:this.businessform.ContactName,
            CertificateType:this.businessform.CertificateType,
            CertificateNo:this.businessform.CertificateNo,
            CompanyName:this.businessform.CompanyName,
            CompanyCertType:this.businessform.CompanyCertType,
            CompanyCertNo:this.businessform.CompanyCertNo,
            AccountName:this.businessform.AccountName,
            Account:this.businessform.Account,
            BankNo:this.businessform.BankNo,
            BankName:this.GetBankNameByBankNo(this.businessform.BankNo),
            AccountType:this.businessform.AccountType,
            Address:this.businessform.Address,
            MerMobilePhone:this.businessform.Phone,
            MobilePhone:this.businessform.MobilePhone,
            NotifyUrl:"",
            Remark:this.businessform.CompanyName
          }
          

          this.ReviewData(RegSubMerInfoRequest);
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    GetBanks()
    {
      return new WebApis.BankApi().FindAll().then((res)=>{
        console.log(res);
         if (res.data.Data) {
             this.Banks=res.data.Data;
         }
      });
    },
    GetBankNameByBankNo(BankNo)
    {
      var BankName="";

      this.Banks.forEach(function(item){
          if(item.BankNo==BankNo)
          {
            BankName= item.BankName;
            return;
          }
      });
      console.log("BankName:",BankName);
      return BankName;
    },
    GetScenics()
    {
      let ScenicSearch={};
       return new WebApis.ScenicApi()
            .GetAllScenic(ScenicSearch).then((res)=>{
                if (res.data.Data) {
                  this.Scenics=res.data.Data;
                }
            });
    },
    GetBusinessType()
    {
      return new WebApis.BusinessTypeApi().FindAll().then((res)=>{
          if (res.data.Data) {
                  this.BusinessTypes=res.data.Data;
          }
       });
    },
    GetInfo() {
      
      if (!this.Business_Id)
      {
        this.businessform.BusinessCode="DF"+new Date().getTime();
      }


      if (this.Business_Id) {
        showLoading(".zj-form-container");

       
        let BusinessSearch = {
          BusinessId: this.Business_Id,
        };

        return new WebApis.BusinessApi()
          .GetItemByBusinessId(BusinessSearch)
          .then((res) => {
            console.log("获取到的Business",res.data.Data);
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.businessform.BusinessIcon = this.resData.BusinessIcon;
              this.businessform.ScenicUUID = this.resData.ScenicId;
              this.businessform.BusinessCode = this.resData.BusinessCode;
              this.businessform.BusinessName = this.resData.BusinessName;
              this.businessform.CompanyName = this.resData.CompanyName;
              this.businessform.ContactName = this.resData.ContactName;
              this.businessform.CompanyCertNo = this.resData.CompanyCertNo;
              this.businessform.CertificateNo = this.resData.CertificateNo;
              this.businessform.AccountName = this.resData.AccountName;
              this.businessform.Account = this.resData.Account;
              this.businessform.AccountType = this.resData.AccountType;
              
              this.businessform.BankNo = this.resData.BankNo;
              this.businessform.BankName = this.GetBankNameByBankNo(this.resData.BankNo);
              this.businessform.MobilePhone = this.resData.MobilePhone;
              this.businessform.Announce = this.resData.Announce;
              
              this.businessform.CertificateType = this.resData.CertificateType;
              this.businessform.CompanyCertType = this.resData.CompanyCertType;
              
              this.businessform.BusinessTypeId = this.resData.BusinessTypeId;
              this.businessform.BusinessCategory = this.resData.BusinessCategory;
              this.businessform.ContactPerson = this.resData.ContactPerson;
              this.businessform.Phone = this.resData.Phone;
              this.businessform.Remarks = this.resData.Remarks;
              this.businessform.Address = this.resData.Address;
              this.businessform.Longitude = this.resData.Longitude;
              this.businessform.Latitude = this.resData.Latitude;
              this.businessform.BusinessState = this.resData.BusinessState+'';
              this.businessform.SubMerSignNo = this.resData.SubMerSignNo;
              this.businessform.StatusMessage = this.resData.StatusMessage;
              this.businessform.SubMerchantSort = this.resData.SubMerchantSort;
              this.businessform.isPassed = this.resData.isPassed;
              this.businessform.AccStatus = this.resData.AccStatus;
              this.businessform.IsABCAccount = this.resData.IsABCAccount;
              this.businessform.Description = this.resData.Description;
              this.businessform.IsSyncToNH = this.resData.IsSyncToNH;
              this.businessform.Proportion=this.resData.Proportion;
              this.businessform.IsMain=this.resData.IsMain;

              if(this.resData.isPassed)
              {
                 this.Isdisabled=true;
              }

              console.log("businessform",this.businessform);
            }
            
            hideLoading();
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取商户信息失败!" + e.RspMsg
                : "获取商户信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    SaveData() {
      let BusinessDTO = {
        Id: 0,
        BusinessId: "",
        BusinessCode: this.businessform.BusinessCode,
        BusinessName: this.businessform.BusinessName,
        BusinessIcon: this.businessform.BusinessIcon,
        BusinessTypeId: this.businessform.BusinessTypeId,
        BusinessCategory:this.businessform.BusinessCategory,
        ContactName:this.businessform.ContactName,
        CertificateType:this.businessform.CertificateType,
        CertificateNo:this.businessform.CertificateNo,
        CompanyName:this.businessform.CompanyName,
        CompanyCertType:this.businessform.CompanyCertType,
        CompanyCertNo:this.businessform.CompanyCertNo,
        AccountName:this.businessform.AccountName,
        Account:this.businessform.Account,
        BankNo:this.businessform.BankNo,
        BankName:this.GetBankNameByBankNo(this.businessform.BankNo),
        MobilePhone:this.businessform.MobilePhone,
        AccountType:this.businessform.AccountType,
        Announce:this.businessform.Announce,
        ScenicId:this.businessform.ScenicUUID,
        ContactPerson:this.businessform.ContactPerson,
        Phone:this.businessform.Phone,
        Remarks:this.businessform.Remarks,
        Address:this.businessform.Address,
        Longitude:this.businessform.Longitude,
        Latitude:this.businessform.Latitude,
        BusinessState:parseInt(this.businessform.BusinessState),
        OrderIndex: 0,
        Description: this.businessform.Description,
        IsSyncToNH: this.businessform.IsSyncToNH,
        IsMain:this.businessform.IsMain,
        Proportion:this.businessform.Proportion,
        Creater: this.user.UserName,
        CreateTime: new Date(),
        Modifier: this.user.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: "",
        Extend2: "",
        Extend3: "",
      };

      if (this.resData) {
        console.log(this.resData);
        BusinessDTO.Id = this.resData.Id;
        BusinessDTO.BusinessId = this.resData.BusinessId;
        BusinessDTO.Modifier = this.user.UserName;
        BusinessDTO.ModifyTime = new Date();
        BusinessDTO.Validity = 1;
        this.UpdateData(BusinessDTO);
      } else {
        this.InsertData(BusinessDTO);
      }
    },
    InsertData(BusinessInfo) {
      console.log("BusinessInfo",BusinessInfo);
      new WebApis.BusinessApi()
        .AddItem(BusinessInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "商户添加成功!",
              type: "success",
            });

            this.CreateOrg();

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "添加商户失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "商户添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "商户添加成功" : "添加商户失败";
          this.logInfo.ModuleName = "统一管理";
          this.logInfo.PageName = "商户管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加商户失败！" + e.RspMsg : "添加商户失败！",
            type: "error",
          });
          return false;
        });
    },
    UpdateData(BusinessInfo) {
      console.log("BusinessInfo",BusinessInfo);
      new WebApis.BusinessApi()
        .UpdateItem(BusinessInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "商户修改成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "修改商户失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "商户修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "商户修改成功" : "修改商户失败";
          this.logInfo.ModuleName = "统一管理";
          this.logInfo.PageName = "商户管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "修改商户失败！" + e.RspMsg : "修改商户失败！",
            type: "error",
          });
          return false;
        });
    },
    ReviewData(RegSubMerInfoRequest) {
      console.log("RegSubMerInfoRequest",RegSubMerInfoRequest);
      new WebApis.BusinessApi()
        .RegSubMerInfoService(RegSubMerInfoRequest)
        .then((res) => {
          if (res.RspCode == "1") {

            if(res.data.Data.Status==0)
            {
              this.$message({
                message: "商户审核已提交!",
                type: "success",
              });

              this.GetBusiessStatus(RegSubMerInfoRequest.SubMerId);
              
              this.$emit("clickOk", {});
            }
            else if(res.data.Data.Status==1)
            {
              this.$message({
                showClose: true,
                message: res.data.Data.Response.Msg,
                type: "error",
              });
              
              return false;
            }
          } else {
            this.$message({
              showClose: true,
              message: "商户提交审核失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "商户提交审核";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "商户提交审核成功" : "商户提交审核失败";
          this.logInfo.ModuleName = "统一管理";
          this.logInfo.PageName = "商户管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "商户提交审核失败" + e.RspMsg : "商户提交审核失败",
            type: "error",
          });
          return false;
        });
    },
    GetBusiessStatus(thisBusinessCode) {
      
      const that = this;
      
      let QrySubMerchantInfo={
        SubMerId:thisBusinessCode
      }


       new WebApis.BusinessApi()
          .QrySubMerchantInfoService(QrySubMerchantInfo)
          .then((r)=>{
            console.log("获取状态",r);
                if (r.RspCode != "1") {
                  that.$message({ type: "success", message: "获取状态失败!" });
                }
          }).catch((e)=>{
            console.log("获取状态失败",e);
            that.$message({
                    showClose: true,
                    message: e ? "获取状态失败!" + e.RspMsg : "获取状态失败!",
                    type: "error",
                  });
          });
    },
    CreateOrg()
    {
      let user = this.user;

      let OrgInfoDTO = {
        Id: 0,
        OrgId: "",
        OrgCode: this.businessform.BusinessCode,
        OrgName: this.businessform.BusinessName,
        OrgShortName: this.businessform.BusinessName,
        ParentOrgId: 'd62677a2-102f-4e84-936a-124abe9ce187',
        OrgTiers: "", //在后台计算
        PersonInCharge: "",
        Phone: "",
        Leader: "",
        DepartmentAddress: "",
        PostalCode: "",
        AllowEdit: 0,
        AllowDelete: 0,
        AreaID: '331000',
        IsCompanyTier: 1,
        Description: "",
        Creater: user.UserName,
        CreateTime: new Date(),
        Modifier: user.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: "",
        Extend2: "",
      };

      var ProductIds=[];
      ProductIds.push("071b54f4-4a34-4a92-a46a-4e358cb98f3e");

      let OrgProductsDTO = {
        orgInfo: OrgInfoDTO,
        ProductIdList: ProductIds,
      };
      console.log("OrgProductsDTO",OrgProductsDTO);
      new WebApis.OrgApi()
        .AddItemAndProductList(OrgProductsDTO)
        .then((res) => {
          if(res.RspCode=="1")
          {
              this.CreaterUser(res.data.Data);
          }
          else
           {
            this.$message({
              showClose: true,
              message: "添加组织机构失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "组织机构添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "组织机构添加成功" : "添加组织机构失败";
          this.logInfo.ModuleName = "统一管理-商户管理";
          this.logInfo.PageName = "组织机构页面";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "添加组织机构失败！" + e.RspMsg
              : "添加组织机构失败！",
            type: "error",
          });
          return false;
        });
    },
    CreaterUser(BusinessId)
    {
      let user = this.user;
       let UserInfoDTO = {
        Id: 0,
        UserId: "",
        Sex: 1,
        Birthday: new Date(),
        UserName: this.businessform.BusinessName,
        LoginName: this.businessform.BusinessCode,
        LoginPwd: "",
        Phone:  this.businessform.Phone,
        AllowEdit: 1,
        AllowDelete: 1,
        AllowUseStartTime: this.get_Day(0),
        AllowUseEndTime: this.get_Day(10 * 356),
        PauseUseStartTime: this.get_Day(-2),
        PauseUseEndTime: this.get_Day(-1),
        Description: "",
        Creater: user.UserName,
        CreateTime: new Date(),
        Modifier: user.UserName,
        ModifyTime: new Date(),
        UserEnabled: true,
        Validity: 1,
        Extend1: "",
        Extend2: "",
        IsCanCustom: 0,
        OrgId: BusinessId,
      };

      new WebApis.UserApi()
        .InsertUser(UserInfoDTO)
        .then((res) => {
          console.log("添加用户返回",res);
          if (res.RspCode == "1") {
            UserInfoDTO.UserId = res.data.Data;
            this.ChoseRole(UserInfoDTO);
          }
          else
          {
            this.$message({
              showClose: true,
              message: "添加用户失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "用户添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户添加成功" : "添加用户失败";
          this.logInfo.ModuleName = "统一管理";
          this.logInfo.PageName = "子商户管理";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log("添加用户失败",e);
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加用户失败！" + e.RspMsg : "添加用户失败！",
            type: "error",
          });
          return false;
        });

    },
    ChoseRole(UserInfoDTO) {
      let user = this.user;
      var LoginUserName = user.UserName;

      var RoleIds=[];
      RoleIds.push("9f259aec-3189-4567-87f2-5974fcc6636f");

      let UserRoleInfoSearch = {
        RoleIds: RoleIds,
        UserId: UserInfoDTO.UserId,
        UserName: UserInfoDTO.UserName,
        LoginName: LoginUserName,
      };

      console.log(UserRoleInfoSearch);

      new WebApis.UserRoleApi()
        .InsertItemList(UserRoleInfoSearch)
        .then((res) => {
          if (res.RspCode != "1") {
            hideLoading();
            this.$message({
              showClose: true,
              message: "授权失败!",
              type: "error",
            });
          }
          this.logInfo.ActionName = "用户分配角色";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户分配角色成功" : "用户分配角色失败";
          this.logInfo.ModuleName = "统一管理";
          this.logInfo.PageName = "子商户管理";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "权限分配失败!" + e.RspMsg : "权限分配失败!",
            type: "error",
          });
        });
    },
    get_Day(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      //let timevalue= new Date(tYear + "-" + tMonth + "-" + tDate);
      let timevalue = tYear + "-" + tMonth + "-" + tDate;
      return timevalue;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    }
  }
};
</script>
